import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useCollectionContract } from "@/hooks/useCollectionContract";
import { useTonConnect } from "@/hooks/useTonConnect";
import BalanceBar from "@/components/atomics/balance-bar";
import { useTonClient } from "@/hooks/useTonCLient";
import { backend } from "@/services/backend";
import { WITHDRAW_LIMIT_BALANCE } from "@/constants/owner-edit";

interface WithdrawManagerProps {
  collection: string;
  walletAddress: string;
  refreshDelay?: number;
}

const WithdrawManager: React.FC<WithdrawManagerProps> = ({
  collection,
  walletAddress,
  refreshDelay = 20000,
}) => {
  const { withdrawEstimate, getAddressBalance } = useCollectionContract();
  const { client } = useTonClient();
  const [displayBalance, setDisplayBalance] = useState(0);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [collectionMaster, setCollectionMaster] = useState<string | null>(null);
  const activeMaster = process.env.MASTER_CONTRACT;

  useEffect(() => {
    backend
      .getCollectionMasterData(collection)
      .then(res => {
        if (res && res.master) {
          setCollectionMaster(res.master);
        }
      })
      .catch(console.error);
  }, [collection]);

  useEffect(() => {
    if (collection && client) {
      getAddressBalance(collection)
        .then(balance => {
          console.log("Balance:", balance);
          if (balance) {
            setDisplayBalance(Number(balance) / 1e9);
          }
        })
        .catch(console.error);
    }
  }, [collection, updateTrigger, client]);

  const handleWithdraw = async () => {
    try {
      await withdrawEstimate(collection, walletAddress);
      setTimeout(() => {
        setUpdateTrigger(prev => !prev);
      }, refreshDelay);
    } catch (e) {
      console.error(e);
    }
  };
  // console.log("Display balance:", displayBalance);
  console.log(
    "Masters:",
    collectionMaster,
    activeMaster,
    collectionMaster === activeMaster
  );
  if (
    !collectionMaster ||
    collectionMaster !== activeMaster ||
    displayBalance < 0.7
  ) {
    return null;
  }

  return (
    <BalanceBar
      count={displayBalance}
      onClick={handleWithdraw}
      isDisabled={displayBalance < WITHDRAW_LIMIT_BALANCE}
    />
  );
};

export default WithdrawManager;
